import type { ValuePropMediaImageType } from "./types";
import { valuePropImagePath } from "./imagePath";

export interface ValuePropImage {
  src: string;
  alt: string;
  mobileSrc?: string;
  width?: number;
  height?: number;
  mobileWidth?: number;
  mobileHeight?: number;
}

export const VALUE_PROP_IMAGES: Record<
  ValuePropMediaImageType,
  ValuePropImage
> = {
  "white-xfinity-router": {
    src: `${valuePropImagePath}white-xfinity-router.jpg`,
    alt: "Xfinity router on a table",
  },
  "two-people-excited-for-risk-free": {
    src: `${valuePropImagePath}two-people-excited-for-risk-free.jpg`,
    alt: "Two people with a laptop during a risk-free trial",
  },
  "woman-smiling-on-phone-call": {
    src: `${valuePropImagePath}woman-smiling-on-phone-call.jpg`,
    alt: "Woman smiling during a phone call",
  },
  "late-night-phone-call-laptop": {
    src: `${valuePropImagePath}late-night-phone-call-laptop.jpg`,
    alt: "Person using a laptop late at night",
  },
  "person-laptop-orange-flowers": {
    src: `${valuePropImagePath}person-laptop-orange-flowers.jpg`,
    alt: "Person smiling at his smartphone while sitting at a dining table with an open laptop, flowers, and fruit in a bright home setting",
  },
  "two-people-working-laptop-smartphone-outdoors": {
    src: `${valuePropImagePath}two-people-working-laptop-smartphone-outdoors.jpg`,
    alt: "Two people sitting outdoors on a rooftop, looking focused while using a laptop and a smartphone together",
  },
  "peacock-premium-icon": {
    src: `${valuePropImagePath}peacock-premium-icon.png`,
    mobileSrc: `${valuePropImagePath}peacock-premium-icon-square.png`,
    alt: "Peacock Premium logo",
    width: 115,
    height: 48,
    mobileWidth: 24,
    mobileHeight: 24,
  },
};
